import request from '@/utils/request'



// 查询商户行业分页
export function pageMerchantMessage(query) {
  return request({
    url: '/biz/admin/merchant/notice/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商户行业详细
export function getMerchantDetail(data) {
  return request({
    url: '/biz/admin/merchant/notice/detail',
    method: 'post',
    data: data
  })
}
